import React, { useState } from "react";
import SPSnackbar from "../components/Navigation/SPSnackbar";

export const SnackbarContext = React.createContext({
  message: "",
  setMessage: () => {},
  setSeverity: () => {},
});

// eslint-disable-next-line react/prop-types
export const SnackbarContextProvider = ({ children, ...rest }) => {
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");

  const handleSetMessage = (newMessage) => {
    if (!newMessage) {
      throw new Error("No message supplied");
    }
    if (typeof newMessage !== "string" && !Array.isArray(newMessage)) {
      throw new Error(`Invalid message type of ${typeof newMessage}`);
    }
    setMessage(newMessage);
  };

  const handleSetSeverity = (newSeverity) => {
    if (!newSeverity) {
      throw new Error("No severity supplied");
    }
    if (typeof newSeverity !== "string") {
      throw new Error(`Invalid message type of ${typeof newSeverity}`);
    }
    setSeverity(newSeverity);
  };

  const handleClose = () => setMessage("");

  return (
    <SnackbarContext.Provider
      value={{
        message,
        setMessage: handleSetMessage,
        setSeverity: handleSetSeverity,
      }}
      {...rest}
    >
      {children}
      <SPSnackbar
        handleClose={handleClose}
        message={message}
        open={Boolean(message)}
        alertSeverity={severity}
      />
    </SnackbarContext.Provider>
  );
};
